export default __webpack_public_path__ + "static/media/8.89dd8280.jpg";